// src/lib/templeMockData.js
// ข้อมูล mock สำหรับแผนที่นิทรรศการวัดและโบราณสถานในเชียงใหม่
// ใช้ร่วมกับ TempleExhibitionPage.jsx (React Leaflet + OpenStreetMap)
//
// โครงสร้างหลัก:
// {
//   id, nameTh, nameEn, district, lat, lng, thumbnail,
//   books: [
//     {
//       id,
//       titleTh, titleEn,
//       authorTh, authorEn,
//       imprintTh, imprintEn,
//       pages,
//       yearBe, yearCe,
//       ageTh, ageEn,
//       regNo,
//       abstractTh, abstractEn,
//     },
//     ...
//   ]
// }

export const MOCK_TEMPLES = [
  /* ─────────────────────────────
   * กลุ่มกำแพงเมืองเชียงใหม่ / ประตูเมือง
   * ───────────────────────────── */

  

  {
    id: "tha-phae-gate",
    nameTh: "ประตูท่าแพ",
    nameEn: "Tha Phae Gate",
    district: "อำเภอเมืองเชียงใหม่ · ด้านตะวันออกของคูเมือง",
    lat: 18.7879,
    lng: 98.993,
    thumbnail: "https://ebookcnx.com/omekas/files/asset/3e704ec8be5e46269897ef6083509d8bc3a1e183.webp",
    books: [
      // ใช้หนังสือกำแพงเมืองเชียงใหม่เป็นเล่มอ้างอิงหลักของบริเวณนี้เช่นกัน
      {
        id: "book-thaphae-1",
        titleTh: "กำแพงเมืองเชียงใหม่",
        titleEn: "The City Walls of Chiang Mai",
        authorTh: "-",
        authorEn: "Anonymous",
        imprintTh: "เชียงใหม่: ทิพย์เนตรการพิมพ์, ๒๕๒๙",
        imprintEn: "Chiang Mai: Thipnet Printing, 1986.",
        pages: 340,
        yearBe: 2529,
        yearCe: 1986,
        ageTh: "อายุ ๓๙ ปี (ข้อมูลปี ๒๕๖๘)",
        ageEn: "39 years old (as of 2025)",
        regNo: "๑๕๐๘",
        abstractTh:
          "หนังสืออนุสรณ์พิธีเปิดและฉลองประตูท่าแพที่บูรณะใหม่ รวบรวมบทความว่าด้วยกำแพงเมือง ประตูเมือง และแจ่งต่างๆ การอ่านจากภาพถ่ายเก่า เอกสารโบราณ และแนวคิดการอนุรักษ์เมืองเก่าเชียงใหม่ เพื่อให้เข้าใจบทบาทของประตูท่าแพในฐานะประตูสำคัญด้านตะวันออกของเมือง.",
        abstractEn:
          "A commemorative volume for the reopening of the restored Tha Phae Gate. It gathers articles on the city walls, gates and bastions of Chiang Mai, drawing on old photographs, historical documents and conservation theories. The book highlights the role of Tha Phae Gate as the main eastern gateway of the old city.",
        readerPath: "/read/42",
        },
    ],
  },

  {
    id: "chang-phuak-gate",
    nameTh: "ประตูช้างเผือก",
    nameEn: "Chang Phueak Gate",
    district: "อำเภอเมืองเชียงใหม่ · ด้านเหนือของคูเมือง",
    lat: 18.7954142,
    lng: 98.9863779,
    thumbnail: "https://ebookcnx.com/omekas/files/asset/3e704ec8be5e46269897ef6083509d8bc3a1e183.webp",
    books: [
      // ใช้หนังสือกำแพงเมืองเชียงใหม่เป็นเล่มอ้างอิงหลักของบริเวณนี้เช่นกัน
      {
        id: "book-thaphae-1",
        titleTh: "กำแพงเมืองเชียงใหม่",
        titleEn: "The City Walls of Chiang Mai",
        authorTh: "-",
        authorEn: "Anonymous",
        imprintTh: "เชียงใหม่: ทิพย์เนตรการพิมพ์, ๒๕๒๙",
        imprintEn: "Chiang Mai: Thipnet Printing, 1986.",
        pages: 340,
        yearBe: 2529,
        yearCe: 1986,
        ageTh: "อายุ ๓๙ ปี (ข้อมูลปี ๒๕๖๘)",
        ageEn: "39 years old (as of 2025)",
        regNo: "๑๕๐๘",
        abstractTh:
          "หนังสืออนุสรณ์พิธีเปิดและฉลองประตูท่าแพที่บูรณะใหม่ รวบรวมบทความว่าด้วยกำแพงเมือง ประตูเมือง และแจ่งต่างๆ การอ่านจากภาพถ่ายเก่า เอกสารโบราณ และแนวคิดการอนุรักษ์เมืองเก่าเชียงใหม่ เพื่อให้เข้าใจบทบาทของประตูท่าแพในฐานะประตูสำคัญด้านตะวันออกของเมือง.",
        abstractEn:
          "A commemorative volume for the reopening of the restored Tha Phae Gate. It gathers articles on the city walls, gates and bastions of Chiang Mai, drawing on old photographs, historical documents and conservation theories. The book highlights the role of Tha Phae Gate as the main eastern gateway of the old city.",
        readerPath: "/read/42",
        },
    ],
  },

  {
    id: "chiang-mai-gate",
    nameTh: "ประตูเชียงใหม่",
    nameEn: "Chiang Mai Gate",
    district: "อำเภอเมืองเชียงใหม่ · ด้านใต้ของคูเมือง",
    lat: 18.7813558,
    lng: 98.9890913,
    thumbnail: "https://ebookcnx.com/omekas/files/asset/3e704ec8be5e46269897ef6083509d8bc3a1e183.webp",
    books: [
      // ใช้หนังสือกำแพงเมืองเชียงใหม่เป็นเล่มอ้างอิงหลักของบริเวณนี้เช่นกัน
      {
        id: "book-thaphae-1",
        titleTh: "กำแพงเมืองเชียงใหม่",
        titleEn: "The City Walls of Chiang Mai",
        authorTh: "-",
        authorEn: "Anonymous",
        imprintTh: "เชียงใหม่: ทิพย์เนตรการพิมพ์, ๒๕๒๙",
        imprintEn: "Chiang Mai: Thipnet Printing, 1986.",
        pages: 340,
        yearBe: 2529,
        yearCe: 1986,
        ageTh: "อายุ ๓๙ ปี (ข้อมูลปี ๒๕๖๘)",
        ageEn: "39 years old (as of 2025)",
        regNo: "๑๕๐๘",
        abstractTh:
          "หนังสืออนุสรณ์พิธีเปิดและฉลองประตูท่าแพที่บูรณะใหม่ รวบรวมบทความว่าด้วยกำแพงเมือง ประตูเมือง และแจ่งต่างๆ การอ่านจากภาพถ่ายเก่า เอกสารโบราณ และแนวคิดการอนุรักษ์เมืองเก่าเชียงใหม่ เพื่อให้เข้าใจบทบาทของประตูท่าแพในฐานะประตูสำคัญด้านตะวันออกของเมือง.",
        abstractEn:
          "A commemorative volume for the reopening of the restored Tha Phae Gate. It gathers articles on the city walls, gates and bastions of Chiang Mai, drawing on old photographs, historical documents and conservation theories. The book highlights the role of Tha Phae Gate as the main eastern gateway of the old city.",
        readerPath: "/read/42",
        },
    ],
  },

  {
    id: "suan-dok-gate",
    nameTh: "ประตูสวนดอก",
    nameEn: "Suan Dok Gate",
    district: "อำเภอเมืองเชียงใหม่ · ด้านตะวันตกของคูเมือง",
    lat: 18.7889862,
    lng: 98.9782674,
    thumbnail: "https://ebookcnx.com/omekas/files/asset/3e704ec8be5e46269897ef6083509d8bc3a1e183.webp",
    books: [
      // ใช้หนังสือกำแพงเมืองเชียงใหม่เป็นเล่มอ้างอิงหลักของบริเวณนี้เช่นกัน
      {
        id: "book-thaphae-1",
        titleTh: "กำแพงเมืองเชียงใหม่",
        titleEn: "The City Walls of Chiang Mai",
        authorTh: "-",
        authorEn: "Anonymous",
        imprintTh: "เชียงใหม่: ทิพย์เนตรการพิมพ์, ๒๕๒๙",
        imprintEn: "Chiang Mai: Thipnet Printing, 1986.",
        pages: 340,
        yearBe: 2529,
        yearCe: 1986,
        ageTh: "อายุ ๓๙ ปี (ข้อมูลปี ๒๕๖๘)",
        ageEn: "39 years old (as of 2025)",
        regNo: "๑๕๐๘",
        abstractTh:
          "หนังสืออนุสรณ์พิธีเปิดและฉลองประตูท่าแพที่บูรณะใหม่ รวบรวมบทความว่าด้วยกำแพงเมือง ประตูเมือง และแจ่งต่างๆ การอ่านจากภาพถ่ายเก่า เอกสารโบราณ และแนวคิดการอนุรักษ์เมืองเก่าเชียงใหม่ เพื่อให้เข้าใจบทบาทของประตูท่าแพในฐานะประตูสำคัญด้านตะวันออกของเมือง.",
        abstractEn:
          "A commemorative volume for the reopening of the restored Tha Phae Gate. It gathers articles on the city walls, gates and bastions of Chiang Mai, drawing on old photographs, historical documents and conservation theories. The book highlights the role of Tha Phae Gate as the main eastern gateway of the old city.",
        readerPath: "/read/42",
        },
    ],
  },

  {
    id: "suan-prung-gate",
    nameTh: "ประตูสวนปรุง",
    nameEn: "Suan Prung Gate",
    district: "อำเภอเมืองเชียงใหม่ · มุมตะวันตกเฉียงใต้ของคูเมือง",
    lat: 18.781558,
    lng: 98.9815939,
    thumbnail: "https://ebookcnx.com/omekas/files/asset/3e704ec8be5e46269897ef6083509d8bc3a1e183.webp",
    books: [
      // ใช้หนังสือกำแพงเมืองเชียงใหม่เป็นเล่มอ้างอิงหลักของบริเวณนี้เช่นกัน
      {
        id: "book-thaphae-1",
        titleTh: "กำแพงเมืองเชียงใหม่",
        titleEn: "The City Walls of Chiang Mai",
        authorTh: "-",
        authorEn: "Anonymous",
        imprintTh: "เชียงใหม่: ทิพย์เนตรการพิมพ์, ๒๕๒๙",
        imprintEn: "Chiang Mai: Thipnet Printing, 1986.",
        pages: 340,
        yearBe: 2529,
        yearCe: 1986,
        ageTh: "อายุ ๓๙ ปี (ข้อมูลปี ๒๕๖๘)",
        ageEn: "39 years old (as of 2025)",
        regNo: "๑๕๐๘",
        abstractTh:
          "หนังสืออนุสรณ์พิธีเปิดและฉลองประตูท่าแพที่บูรณะใหม่ รวบรวมบทความว่าด้วยกำแพงเมือง ประตูเมือง และแจ่งต่างๆ การอ่านจากภาพถ่ายเก่า เอกสารโบราณ และแนวคิดการอนุรักษ์เมืองเก่าเชียงใหม่ เพื่อให้เข้าใจบทบาทของประตูท่าแพในฐานะประตูสำคัญด้านตะวันออกของเมือง.",
        abstractEn:
          "A commemorative volume for the reopening of the restored Tha Phae Gate. It gathers articles on the city walls, gates and bastions of Chiang Mai, drawing on old photographs, historical documents and conservation theories. The book highlights the role of Tha Phae Gate as the main eastern gateway of the old city.",
        readerPath: "/read/42",
        },
    ],
  },

  /* ─────────────────────────────
   * กลุ่มวัดและสถาบันความรู้
   * ───────────────────────────── */

  {
    id: "wat-maha-photaram",
    nameTh: "วัดมหาโพธาราม",
    nameEn: "Wat Maha Photaram",
    district: "อำเภอเมืองเชียงใหม่ · เขตเมืองเก่า/ย่านท่าแพ",
    lat: 18.8090186,
    lng: 98.9717327,
    thumbnail: "https://ebookcnx.com/omekas/files/asset/98ad0b6a79f7ad317620ad5b53b6df122421ca06.webp",
    books: [
      {
        id: "book-maha-photaram-1",
        titleTh: "ตำนานวัดมหาโพธาราม (เจ็ดยอด)",
        titleEn: "Legend of Wat Maha Photaram (Chet Yot)",
        authorTh: "-",
        authorEn: "Anonymous",
        imprintTh: "เชียงใหม่: โรงพิพม์มหากุฏราชวิทยาลัย, ๒๕๑๘",
        imprintEn: "Chiang Mai: Mahamakut Royal Institute Press, 1975.",
        pages: 78,
        yearBe: 2518,
        yearCe: 1975,
        ageTh: "อายุ ๕๐ ปี (ข้อมูลปี ๒๕๖๘)",
        ageEn: "50 years old (as of 2025)",
        regNo: "๒๙๔.๓๑๓๕ ต ๓๕๙",
        abstractTh:
          "หนังสือเล่มนี้จัดพิมพ์ขึ้นเป็นธรรมบรรณาการในงานพระราชทานเพลิงศพพระครูอุดมโพธิคุณ อดีตเจ้าอาวาสวัดเจ็ดยอด เนื้อหาหลักเป็นการรวบรวมตำนานวัดเจ็ดยอด ซึ่งเป็นพระอารามหลวงที่พระเจ้าติโลกราช กษัตริย์ล้านนาไทยทรงสร้างขึ้น ตลอดจนบทบาทของวัดในฐานะสถานที่ทำอัฏฐมสังคายนาพระไตรปิฎกครั้งที่ ๘ ของโลก และที่พำนักของพระเถระนักปราชญ์ผู้รจนาคัมภีร์สำคัญของล้านนา จึงเป็นแหล่งความรู้ด้านประวัติศาสตร์ วัฒนธรรม และพระพุทธศาสนาในนครเชียงใหม่อย่างสำคัญ.",
        abstractEn:
          "This book was published as a religious offering on the occasion of the royal cremation of Phra Khru Udomphotikun, former abbot of Wat Chet Yot. It compiles legends and historical accounts of Wat Chet Yot, a royal monastery founded by King Tilokkarat of Lanna. The text highlights the temple’s role as the venue of the Eighth Buddhist Council and as a residence of learned monks who authored important Lanna scriptures, making the book a key source for the history, culture and Buddhist heritage of Chiang Mai.",
        readerPath: "/read/59",
        },
    ],
  },

  {
    id: "wat-umong",
    nameTh: "วัดอุโมงค์ (สุเทพป่าตอง)",
    nameEn: "Wat Umong Suan Phutthatham",
    district: "อำเภอเมืองเชียงใหม่ · เชิงดอยสุเทพ ถ.สุเทพ",
    lat: 18.7827263,
    lng: 98.9521099,
    thumbnail: "https://ebookcnx.com/omekas/files/asset/6c57d93ed30aa4e33ca4a990901bb676edaa614d.webp",
    books: [
      {
        id: "book-umong-1",
        titleTh: "ประวัติวัดอุโมงค์",
        titleEn: "History of Wat Umong",
        authorTh: "ชุ่ม ณ บางช้าง",
        authorEn: "Chum Na Bangchang",
        imprintTh: "เชียงใหม่: พระสิงห์การพิมพ์, ๒๕๒๑",
        imprintEn: "Chiang Mai: Phra Singh Printing, 1978.",
        pages: 64,
        yearBe: 2521,
        yearCe: 1978,
        ageTh: "อายุ ๔๗ ปี (ข้อมูลปี ๒๕๖๘)",
        ageEn: "47 years old (as of 2025)",
        regNo: "๒๔๒๖",
        abstractTh:
          "หนังสือเล่มนี้เรียบเรียงขึ้นตามคำปรารภของเจ้าอาวาสวัดอุโมงค์ (ศรีภูมิ) เพื่อบันทึกประวัติของวัดเก่าแก่แห่งนี้ เนื้อหากล่าวถึงความเป็นมาของวัดอุโมงค์สองแห่งในเชียงใหม่ ทั้งในและนอกกำแพงเมือง ซึ่งเชื่อมโยงกันผ่านพระมหาเถรจันทร์ ผู้เป็นเจ้าอาวาสร่วมกัน หนังสือให้รายละเอียดชีวประวัติพระมหาเถรผู้แตกฉานในพระธรรมแต่มีอาการคลุ้มดีคลุ้มร้าย อันนำไปสู่การสร้างวัดอุโมงค์ (นอกเมือง) ที่มีอุโมงค์ใต้ดินโดยพระราชศรัทธาของพระเจ้ากือนา นอกจากนี้ยังกล่าวถึงเหตุที่วัดหลายแห่งกลายเป็นวัดร้างจากภัยสงคราม ทำให้หนังสือเล่มนี้เป็นสะพานเชื่อมคนรุ่นหลังกับมรดกทางประวัติศาสตร์และวัฒนธรรมล้านนา.",
        abstractEn:
          "Compiled at the request of the abbot of Wat Umong (Sri Phum), this book records the history of this ancient monastery. It traces the stories of two Wat Umong temples in Chiang Mai, inside and outside the city walls, linked through the figure of Phra Maha Then Chan, who served as abbot of both. The author presents the monk’s life, renowned for his deep understanding of the Dhamma yet marked by episodes of erratic behavior, which inspired King Kuena to establish the forest temple with underground tunnels outside the city. The book also explains how many temples in Chiang Mai became abandoned due to war, thus serving as a bridge that connects later generations to the historical and cultural heritage of Lanna.",
        readerPath: "/read/63",
        },
    ],
  },

  {
    id: "national-library-ratchamangkhalaphisek",
    nameTh: "หอสมุดแห่งชาติรัชมังคลาภิเษก เชียงใหม่",
    nameEn: "Ratchamangkhalaphisek National Library, Chiang Mai",
    district: "อำเภอเมืองเชียงใหม่ · ถ.ห้วยแก้ว ใกล้สวนรุกขชาติ",
    lat: 18.7878027,
    lng: 98.9776862,
    thumbnail: "https://ebookcnx.com/omekas/files/asset/b1321c1ecd079b9934dc6211978bf60ae7903b1d.webp",
    books: [
      {
        id: "book-ratchamangkhalaphisek-1",
        titleTh: "ที่ระลึกในพิธีเปิด หอสมุดแห่งชาติ รัชมังคลาภิเษก เชียงใหม่",
        titleEn:
          "Souvenir of the Opening Ceremony of the Ratchamangkhalaphisek National Library, Chiang Mai",
        authorTh:
          "คณะกรรมการอำนวยการจัดสร้างหอสมุดแห่งชาติ รัชมังคลาภิเษก เชียงใหม่",
        authorEn:
          "Executive Committee for the Construction of the Ratchamangkhalaphisek National Library, Chiang Mai",
        imprintTh:
          "กรุงเทพฯ: บริษัทอมรินทร์ พริ้นติ้ง กรุ๊พ จำกัด, ๒๕๓๒",
        imprintEn:
          "Bangkok: Amarin Printing Group Co., Ltd., 1989.",
        pages: 78,
        yearBe: 2532,
        yearCe: 1989,
        ageTh: "อายุ ๓๖ ปี (ข้อมูลปี ๒๕๖๘)",
        ageEn: "36 years old (as of 2025)",
        regNo: "๐๒๗.๕๕๙๓ ค ๑๒๔ ท",
        abstractTh:
          "หนังสือที่ระลึกเล่มนี้จัดทำขึ้นในโอกาสพิธีเปิดหอสมุดแห่งชาติ รัชมังคลาภิเษก เชียงใหม่ ซึ่งสมเด็จพระเทพรัตนราชสุดาฯ สยามบรมราชกุมารี เสด็จพระราชดำเนินทรงเป็นองค์ประธาน แนวคิดการจัดสร้างเกิดจากดำริของพลเอกเปรม ติณสูลานนท์ เพื่อถวายเป็นราชสักการะในพระราชพิธีรัชมังคลาภิเษก เนื้อหาเล่าถึงความเป็นมาของโครงการ การระดมความร่วมมือจากทุกภาคส่วน และบทบาทของหอสมุดแห่งนี้ในฐานะแหล่งศูนย์กลางข้อมูลและมรดกเอกสารของภาคเหนือ.",
        abstractEn:
          "This commemorative publication was produced for the opening ceremony of the Ratchamangkhalaphisek National Library, Chiang Mai, presided over by Her Royal Highness Princess Maha Chakri Sirindhorn. The library was initiated by General Prem Tinsulanonda as an offering in celebration of the Ratchamangkhalaphisek ceremony marking the longest reign of King Bhumibol Adulyadej. The book recounts the origins of the project, the collaboration of many sectors in its construction, and the library’s mission as a central repository of documentary heritage and knowledge resources for northern Thailand.",
        readerPath: "/read/61",
        },
    ],
  },

  {
    id: "wat-phra-that-doi-suthep",
    nameTh: "วัดพระธาตุดอยสุเทพราชวรวิหาร",
    nameEn: "Wat Phra That Doi Suthep",
    district: "อำเภอเมืองเชียงใหม่ · ดอยสุเทพ",
    lat: 18.8049889,
    lng: 98.9216337,
    thumbnail: "https://ebookcnx.com/omekas/files/asset/876b6bd88658f9effc9394b282525d7e394167a8.webp",
    books: [
      {
        id: "book-doi-suthep-1",
        titleTh: "ตำนานพระบรมธาตุดอยสุเทพ",
        titleEn: "Legend of Phra Borommathat Doi Suthep",
        authorTh: "-",
        authorEn: "Anonymous",
        imprintTh: "ม.ป.ท.: ม.ป.พ., ๒๔๘๒",
        imprintEn: "n.p.: n.p., 1939.",
        pages: 34,
        yearBe: 2482,
        yearCe: 1939,
        ageTh: "อายุ ๘๖ ปี (ข้อมูลปี ๒๕๖๘)",
        ageEn: "86 years old (as of 2025)",
        regNo: "๒๑๒๔",
        abstractTh:
          "หนังสือเล่มนี้จัดพิมพ์เป็นที่ระลึกในงานพระราชทานเพลิงศพนายพลตรีเจ้าแก้วนวรัฐ เจ้าผู้ครองนครเชียงใหม่ ผู้มีบทบาทสำคัญในการบำรุงพระบรมธาตุดอยสุเทพ เนื้อหาเสนอประวัติและตำนานพระบรมธาตุดอยสุเทพ ตั้งแต่การอัญเชิญพระบรมสารีริกธาตุมาประดิษฐาน การสร้างวัดวาอารามบนดอย จนถึงบทบาทของเจ้าแก้วนวรัฐในฐานะผู้ทำนุบำรุงพระพุทธศาสนาและวัดแห่งนี้ เป็นแหล่งข้อมูลสำคัญด้านประวัติศาสตร์และศาสนาของภาคเหนือ.",
        abstractEn:
          "Published as a memorial for the royal cremation of Major General Chao Kaew Nawarat, the last ruling prince of Chiang Mai, this booklet focuses on the legend of Phra Borommathat Doi Suthep. It recounts the story of how the Buddha relic was brought and enshrined on the mountain, the founding of the temple complex, and the role of Chao Kaew Nawarat in supporting the monastery and Buddhism. The text is an important source for the religious and historical significance of Doi Suthep in northern Thailand.",
        readerPath: "/read/36",
      },
      {
        id: "book-doi-suthep-2",
        titleTh: "ตำนานพระธาตุดอยสุเทพนครเชียงใหม่",
        titleEn: "Legend of Phra That Doi Suthep, Chiang Mai",
        authorTh: "สงวน โชติสุขรัตน์",
        authorEn: "Sanguan Chotisukharat",
        imprintTh: "เชียงใหม่: สงวนการพิมพ์, ๒๕๑๐",
        imprintEn: "Chiang Mai: Sanguan Printing, 1967.",
        pages: 36,
        yearBe: 2510,
        yearCe: 1967,
        ageTh: "อายุ ๕๘ ปี (ข้อมูลปี ๒๕๖๘)",
        ageEn: "58 years old (as of 2025)",
        regNo: "๑๙๕๙",
        abstractTh:
          "หนังสือเล่มนี้นำเสนอประวัติความเป็นมาของวัดพระธาตุดอยสุเทพ การก่อสร้าง และสิ่งศักดิ์สิทธิ์ภายในวัด รวมถึงพิธีกรรมทางศาสนาและบทสวดที่ใช้ในงานสำคัญ ผู้เขียนยังเล่าถึงการบูรณะซ่อมแซมวัด การมีส่วนร่วมของพุทธศาสนิกชนในการบำรุงรักษาวัด ตลอดจนข้อมูลเกี่ยวกับระฆังใหญ่และค่าใช้จ่ายในการบำรุงรักษา แสดงให้เห็นถึงความศรัทธาและความสำคัญของวัดแห่งนี้ทั้งในมิติประวัติศาสตร์และศาสนา.",
        abstractEn:
          "This booklet presents the history of Wat Phra That Doi Suthep, its construction and sacred objects, together with the religious ceremonies and chants associated with major events. The author describes restoration works, the participation of lay Buddhists in maintaining the temple, and details such as the great bell and the costs of upkeep. It reveals both the deep faith of devotees and the historical and religious importance of the monastery on Doi Suthep.",
        readerPath: "/read/96",
        },
    ],
  },

  {
    id: "wat-phra-singh",
    nameTh: "วัดพระสิงห์วรมหาวิหาร",
    nameEn: "Wat Phra Singh Woramahawihan",
    district: "อำเภอเมืองเชียงใหม่ · คูเมืองด้านใน (ถ.สามล้าน)",
    lat: 18.7885265,
    lng: 98.9819946,
    thumbnail: "https://ebookcnx.com/omekas/files/asset/7fc583b03d60d69555b536cfa0c667671d36553d.webp",
    books: [
      {
        id: "book-phra-singh-1",
        titleTh: "ประวัติการส้างพระพุทธรูปประจำวัน พระ ๗ ปาง",
        titleEn:
          "History of the Creation of the Seven Day-of-the-Week Buddha Images",
        authorTh: "พุทธสมาคมแห่งประเทสไทย สาขาจังหวัดเชียงใหม่",
        authorEn:
          "Buddhist Association of Thailand, Chiang Mai Branch",
        imprintTh: "เชียงใหม่: โรงพิมพ์อุปติพงส์, ๒๔๘๖",
        imprintEn: "Chiang Mai: Uppatipong Printing House, 1943.",
        pages: 22,
        yearBe: 2486,
        yearCe: 1943,
        ageTh: "อายุ ๘๒ ปี (ข้อมูลปี ๒๕๖๘)",
        ageEn: "82 years old (as of 2025)",
        regNo: "๓๗๖",
        abstractTh:
          "หนังสือเล่มนี้บันทึกประวัติการสร้างพระพุทธรูปประจำวัน ๗ ปาง ณ วัดพระสิงห์ จังหวัดเชียงใหม่ มีวัตถุประสงค์เพื่อให้ความรู้เกี่ยวกับความเชื่อเรื่องพระประจำวันในสังคมไทย เนื้อหาอธิบายความศรัทธาในเครื่องรางของขลังและแรงปรารถนาในการสร้างสิ่งศักดิ์สิทธิ์เพื่อเป็นที่พึ่งทางใจ พร้อมทั้งให้รายละเอียดพิธีกรรม ขั้นตอนการสร้างพระพุทธรูป และวัตถุมงคลที่นำมาจากปูชนียสถานสำคัญในจังหวัดต่างๆ แสดงให้เห็นถึงความแพร่หลายและความสำคัญของพระพุทธรูปในวัฒนธรรมไทย.",
        abstractEn:
          "This booklet records the history of creating the seven day-of-the-week Buddha images at Wat Phra Singh in Chiang Mai. It aims to explain the Thai belief in “Buddha images for each day” and the role of sacred objects as sources of spiritual protection. The text describes faith in amulets, the desire to create new sacred images, the rituals and steps of casting the statues, and the consecrated materials brought from important Buddhist sites across the country, illustrating the widespread significance of Buddha images in Thai culture.",
        readerPath: "/read/38",
      },
    ],
  },

  {
    id: "wat-chedi-luang",
    nameTh: "วัดเจดีย์หลวงวรวิหาร",
    nameEn: "Wat Chedi Luang",
    district: "อำเภอเมืองเชียงใหม่ · คูเมืองด้านใน (กลางเมืองเก่า)",
    lat: 18.7869693,
    lng: 98.9865804,
    thumbnail: "https://ebookcnx.com/omekas/files/asset/3abee6a6e6c1a173d695f5a58ba2cc7fd5d5f55f.webp",
    books: [
      {
        id: "book-chedi-luang-1",
        titleTh: "ตำนานวัดเจดีย์หลวงและตำนานอินทขิล",
        titleEn:
          "Legend of Wat Chedi Luang and the Inthakhin City Pillar",
        authorTh: "วัดเจดีย์หลวง",
        authorEn: "Wat Chedi Luang",
        imprintTh: "ม.ป.ท.: ม.ป.พ., ๒๕๒๓",
        imprintEn: "n.p.: n.p., 1980.",
        pages: 22,
        yearBe: 2523,
        yearCe: 1980,
        ageTh: "อายุ ๔๕ ปี (ข้อมูลปี ๒๕๖๘)",
        ageEn: "45 years old (as of 2025)",
        regNo: "๒๔๘๒",
        abstractTh:
          "หนังสือเล่มนี้จัดพิมพ์ขึ้นเพื่อเป็นที่ระลึกในงานประเพณีบูชาอินทขิล ประจำปี ๒๕๒๓ เนื้อหาหลักประกอบด้วยตำนานพระธาตุเจดีย์หลวง เล่าประวัติความเป็นมาของวัดเจดีย์หลวงในเชียงใหม่ และตำนานอินทขิลที่กล่าวถึงเสาหลักเมืองโบราณและประเพณีการบูชาที่จัดขึ้นทุกปีในเดือน ๘ เหนือ เป็นเวลา ๗ วัน นอกจากนี้ยังมีรายละเอียดเกี่ยวกับปูชนียวัตถุและโบราณวัตถุในบริเวณวัดเจดีย์หลวงด้วย.",
        abstractEn:
          "Published as a souvenir for the annual Inthakhin worship festival in 1980, this booklet contains legends of the great chedi of Wat Chedi Luang and the Inthakhin city pillar. It recounts the origins of the temple in Chiang Mai, the story of the ancient pillar that serves as the city’s spiritual axis, and the seven-day ritual held every eighth lunar month in the northern calendar. The book also describes sacred objects and antiquities within the temple grounds.",
        readerPath: "/read/34",
        },
    ],
  },
];
